

export class VehicleLicenseDetailsOutput implements IVehicleLicenseDetailsOutput {
    /** The auto-generated id of the vehicle license details master */
    vehicle_license_id!: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The branch with 255 character limit */
    branch!: string;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The vehicle number with 255 character limit */
    vehicle_number!: string;
    /** The vehicle name with 255 character limit */
    vehicle_name!: string;
    /** The license issue date with 10 character limit */
    license_issue_date!: string;
    /** The license activation date with 10 character limit */
    license_activation_date!: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date!: string;
    /** The license extended date with 10 character limit */
    license_extend_date!: string;
    /** Expiry message in days */
    show_expiry_message!: number;
    /** The remark with 500 character limit */
    remark!: string;
    /** Notify vehicle license. 0 For No, 1 For Yes */
    notify!: number;
    /** Manage vehicle license details. 0 For De-active, 1 For Active */
    status!: number;
    /** The auto-generated creating time of tbl_vehicle_license item add */
    creating_date!: any;
    /** The auto-generated creating or updating time of tbl_company_license_details item add or update */
    updating_date!: any;

    constructor(data?: IVehicleLicenseDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_license_id = _data["vehicle_license_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.branch = _data["branch"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.vehicle_number = _data["vehicle_number"];
            this.vehicle_name = _data["vehicle_name"];
            this.license_issue_date = _data["license_issue_date"];
            this.license_activation_date = _data["license_activation_date"];
            this.license_expiry_date = _data["license_expiry_date"];
            this.license_extend_date = _data["license_extend_date"];
            this.show_expiry_message = _data["show_expiry_message"];
            this.remark = _data["remark"];
            this.notify = _data["notify"];
            this.status = _data["status"];
            this.creating_date = _data["creating_date"];
            this.updating_date = _data["updating_date"];
        }
    }

    static fromJS(data: any): VehicleLicenseDetailsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLicenseDetailsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_license_id"] = this.vehicle_license_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["branch"] = this.branch;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["vehicle_number"] = this.vehicle_number;
        data["vehicle_name"] = this.vehicle_name;
        data["license_issue_date"] = this.license_issue_date;
        data["license_activation_date"] = this.license_activation_date;
        data["license_expiry_date"] = this.license_expiry_date;
        data["license_extend_date"] = this.license_extend_date;
        data["show_expiry_message"] = this.show_expiry_message;
        data["remark"] = this.remark;
        data["notify"] = this.notify;
        data["status"] = this.status;
        data["creating_date"] = this.creating_date;
        data["updating_date"] = this.updating_date;
        return data; 
    }
}

export interface IVehicleLicenseDetailsOutput {
    /** The auto-generated id of the vehicle license details master */
    vehicle_license_id: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The branch with 255 character limit */
    branch: string;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The vehicle number with 255 character limit */
    vehicle_number: string;
    /** The vehicle name with 255 character limit */
    vehicle_name: string;
    /** The license issue date with 10 character limit */
    license_issue_date: string;
    /** The license activation date with 10 character limit */
    license_activation_date: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date: string;
    /** The license extended date with 10 character limit */
    license_extend_date: string;
    /** Expiry message in days */
    show_expiry_message: number;
    /** The remark with 500 character limit */
    remark: string;
    /** Notify vehicle license. 0 For No, 1 For Yes */
    notify: number;
    /** Manage vehicle license details. 0 For De-active, 1 For Active */
    status: number;
    /** The auto-generated creating time of tbl_vehicle_license item add */
    creating_date: any;
    /** The auto-generated creating or updating time of tbl_company_license_details item add or update */
    updating_date: any;
}

